<template>
  <div class="banner-swiper">
    <swiper
      style="width: 100%; height: 100%;"
      ref="swiperRef"
      :modules="[Pagination, Autoplay]"
      :autoplay="false"
      :loop="banners.length + 1 > 1"
      :pagination="banners.length + 1 > 1 ? { clickable: true, el: '.swiper-pagination' } : false"
      @slideChange="onSlideChange"
      @swiper="onSwiper"
    >
      <swiper-slide>
        <div class="banner-img-wrap">
          <video
            ref="bannerVideo"
            :src="videoSrc"
            autoplay
            muted
            playsinline
            @ended="onVideoEnded"
          ></video>
        </div>
      </swiper-slide>
      <swiper-slide v-for="(banner, idx) in banners" :key="banner.img">
        <div class="banner-img-wrap">
          <img
            :src="banner.img"
            alt="banner"
            :class="{ active: isActiveImg(idx) }"
          />
          <div :class="['banner-text', { active: isActiveImg(idx) }]">
            <div class="banner-title">{{ banner.title }}</div>
            <div class="banner-subtitle">{{ banner.subtitle }}</div>
            <div class="banner-en">{{ banner.en }}</div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!-- 分页按钮统一放在 Banner 区域底部 -->
    <div
      v-if="banners.length + 1 > 1"
      class="swiper-pagination custom-swiper-pagination"
    ></div>
    <slot></slot>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const videoSrc = '/videos/index.mp4'; // 本地视频
const banners = [
  {
    img: '/images/index1.jpg',
    title: '初心不忘 源见未来',
    subtitle: '只有不忘初心 同舟共济 方可成就大业',
    en: "Never forget the origin and see the future in one's original intention Only by not forgetting our original intention and working together can we achieve great success"
  },
  {
    img: '/images/index2.jpg',
    title: '乐善社会 由我做起',
    subtitle: '发展好企业的同时，积极做慈善回报社会',
     en: "Never forget the origin and see the future in one's original intention Only by not forgetting our original intention and working together can we achieve great success"
  }
];

const swiperRef = ref(null);
const bannerVideo = ref(null);
const swiperInstance = ref(null);

const onSwiper = (swiper) => {
  swiperInstance.value = swiper;
};

const onVideoEnded = () => {
  if (swiperInstance.value) {
    swiperInstance.value.slideNext();
  }
};

const onSlideChange = () => {
  if (swiperInstance.value && swiperInstance.value.realIndex === 0) {
    bannerVideo.value && bannerVideo.value.play();
  }
};

// 判断当前图片是否为激活状态
const isActiveImg = (idx) => {
  return swiperInstance.value && swiperInstance.value.realIndex === idx + 1;
};
</script>

<script>
export default {
  name: 'BannerSwiper'
}
</script>

<style scoped>
.banner-swiper {
  width: 100vw;
  height: 100vh;
  position: relative;
}
.banner-img-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.banner-swiper video,
.banner-swiper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-swiper img {
  transition: transform 2s ease;
  transform: scale(1);
}
.banner-swiper img.active {
  transform: scale(1.2);
}
.banner-text {
  position: absolute;
  left: 120px;
  top: 35vh;
  color: #fff;
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 2s ease, transform 2s ease;
  z-index: 2;
  max-width: 500px;
  min-width: 320px;
  padding: 0 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.banner-text.active {
  opacity: 1;
  transform: translateY(0);
}
.banner-title {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 16px;
  line-height: 1.2;
}
.banner-subtitle {
  font-size: 24px;
  margin-bottom: 12px;
  line-height: 1.5;
}
.banner-en {
  font-size: 16px;
  opacity: 0.85;
  line-height: 1.5;
  margin-bottom: 24px;
  text-shadow: 2px 2px 0 #1f3c82;
}
.custom-swiper-pagination {
  position: absolute;
  left: 150px;
  bottom: 40px;
  /* transform: translateX(-50%); */
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 10;
}
:deep(.custom-swiper-pagination .swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  background: rgba(255,255,255,0.4) !important;
  opacity: 1;
  border-radius: 50%;
  margin: 0;
  transition: all 0.3s cubic-bezier(.4,0,.2,1);
  display: inline-block;
}
:deep(.custom-swiper-pagination .swiper-pagination-bullet-active) {
  width: 25px;
  height: 10px;
  background: #fff !important;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
</style> 